// extracted by mini-css-extract-plugin
export default {"root":"QuotaCleanerPlug__root--2vt6T","text":"QuotaCleanerPlug__text--3GbA7","button":"QuotaCleanerPlug__button--tpZov"};